import { useEffect } from 'react';
import img1 from "../../images/AE-img-1.jpg";
import img2 from "../../images/AE-img-11.jpeg";
import Logo from "../../images/AE-Hero.svg";
import { Link } from "react-router-dom";
import { FiCheckCircle, FiZap, FiShield, FiTrendingUp, FiWind } from 'react-icons/fi';

const About = () => {
    useEffect(() => {
        // Refresh AOS animations when component mounts
        if (typeof window !== 'undefined') {
            const AOS = require('aos');
            AOS.refresh();
        }
    }, []);

    return (
        <>
            <section id="about" className="about py-16 bg-gray-50 relative">
                <div className="absolute top-6 right-6 z-10">
                    <img src={Logo} alt="Alternative Energy" className="h-10 w-auto md:h-14 opacity-80" />
                </div>
                <div className="content">
                    <div className="container mx-auto px-4">
                        <div className="flex flex-wrap -mx-4">
                            <div className="w-full lg:w-1/2 px-4 mb-8 lg:mb-0">
                                <img src={img1} alt="Complete energy system installation" className="w-full h-auto img-overlap rounded-lg shadow-lg" data-aos="zoom-out" />
                            </div>
                            <div className="w-full lg:w-5/12 lg:ml-auto px-4" data-aos="fade-up" data-aos-delay="100">
                                <h3 className="text-lg text-orange-400 font-semibold mb-2">WHY CHOOSE US</h3>
                                <h2 className="text-3xl lg:text-4xl font-bold mb-6 text-white">
                                    Over <strong className="font-extrabold text-orange-400">15 years of expertise</strong> in integrated energy solutions
                                </h2>
                                <p className="text-white/90 mb-6">
                                    Alternative Energy (PTY) LTD is an Eswatini based Electrical and Solar Company that was established in 2009, proudly woman owned & operated by Tasmia Young who founded the company in 2009. The company has the capacity to deliver a range of electrical and solar projects to clients in different industries and sectors. Alternative Energy has been operating for 10 years already and is driven by two principles: Strong customer service and a commitment of seeking viable solutions within the Electrical and Solar industry.
                                </p>

                                <div className="space-y-6 my-8">
                                    <div className="flex items-start">
                                        <div className="bg-orange-600 p-3 rounded-lg mr-4">
                                            <FiZap className="text-2xl text-white" />
                                        </div>
                                        <div>
                                            <h4 className="text-orange-400 text-xl font-semibold mb-1">Complete Energy Solutions</h4>
                                            <p className="text-white/80">Integrated solar and electrical systems designed for maximum efficiency and reliability</p>
                                        </div>
                                    </div>
                                    <div className="flex items-start">
                                        <div className="bg-orange-600 p-3 rounded-lg mr-4">
                                            <FiShield className="text-2xl text-white" />
                                        </div>
                                        <div>
                                            <h4 className="text-orange-400 text-xl font-semibold mb-1">Certified & Insured</h4>
                                            <p className="text-white/80">Licensed electricians and NABCEP-certified solar technicians ensuring code compliance and safety</p>
                                        </div>
                                    </div>
                                    <div className="flex items-start">
                                        <div className="bg-orange-600 p-3 rounded-lg mr-4">
                                            <FiTrendingUp className="text-2xl text-white" />
                                        </div>
                                        <div>
                                            <h4 className="text-orange-400 text-xl font-semibold mb-1">Performance & Safety Guarantee</h4>
                                            <p className="text-white/80">25-year solar performance warranties combined with electrical safety certifications</p>
                                        </div>
                                    </div>
                                    <div className="flex items-start">
                                        <div className="bg-orange-600 p-3 rounded-lg mr-4">
                                            <FiWind className="text-2xl text-white" />
                                        </div>
                                        <div>
                                            <h4 className="text-orange-400 text-xl font-semibold mb-1">Generator Solutions</h4>
                                            <p className="text-white/80">Reliable backup power with professional generator supply, installation, maintenance, and rental services</p>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </section>

            <section id="about-3" className="about-3 py-16 bg-white relative">
                <div className="absolute top-4 right-6 z-10">
                    <img src={Logo} alt="Alternative Energy" className="h-10 w-auto md:h-14 opacity-80" />
                </div>
                <div className="container mx-auto px-4">
                    <div className="flex flex-wrap -mx-4 items-center justify-between">
                        <div className="w-full lg:w-1/2 px-4 order-2 lg:order-2 relative" data-aos="zoom-out">
                            <img src={img2} alt="Energy technician installing integrated systems" className="w-full h-auto rounded-lg shadow-lg" />
                        </div>
                        <div className="w-full lg:w-5/12 px-4 order-1 lg:order-1" data-aos="fade-up" data-aos-delay="100">
                            <h2 className="text-3xl lg:text-4xl font-bold mb-6 text-gray-600">Integrated Energy Systems Transform Lives</h2>
                            <p className="mb-6 text-gray-600">
                                We believe in comprehensive energy solutions that combine renewable solar power, reliable electrical infrastructure, and professional generator services. Our mission is to empower homes and businesses with integrated systems that reduce energy costs, enhance safety, and minimize environmental impact. With our complete energy approach, you're not just installing solar panels—you're upgrading your entire energy ecosystem for efficiency, reliability, and sustainability, backed by dependable generator backup power whenever you need it.
                            </p>

                            <div className="mb-8">
                                <h3 className="text-xl font-semibold text-gray-800 mb-4">Our Integrated Services Include:</h3>
                                <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
                                    <div className="flex items-start mb-3">
                                        <FiCheckCircle className="w-5 h-5 text-orange-500 mr-3 mt-0.5 flex-shrink-0" />
                                        <span className="text-gray-600">Solar system design with electrical integration planning</span>
                                    </div>
                                    <div className="flex items-start mb-3">
                                        <FiCheckCircle className="w-5 h-5 text-orange-500 mr-3 mt-0.5 flex-shrink-0" />
                                        <span className="text-gray-600">Complete electrical rewiring and panel upgrades</span>
                                    </div>
                                    <div className="flex items-start mb-3">
                                        <FiCheckCircle className="w-5 h-5 text-orange-500 mr-3 mt-0.5 flex-shrink-0" />
                                        <span className="text-gray-600">Smart energy monitoring and management systems</span>
                                    </div>
                                    <div className="flex items-start mb-3">
                                        <FiCheckCircle className="w-5 h-5 text-orange-500 mr-3 mt-0.5 flex-shrink-0" />
                                        <span className="text-gray-600">Battery storage with backup generator integration</span>
                                    </div>
                                    <div className="flex items-start mb-3">
                                        <FiCheckCircle className="w-5 h-5 text-orange-500 mr-3 mt-0.5 flex-shrink-0" />
                                        <span className="text-gray-600">Energy-efficient lighting and appliance upgrades</span>
                                    </div>
                                    <div className="flex items-start mb-3">
                                        <FiCheckCircle className="w-5 h-5 text-orange-500 mr-3 mt-0.5 flex-shrink-0" />
                                        <span className="text-gray-600">Unified maintenance for solar and electrical systems</span>
                                    </div>
                                    <div className="flex items-start mb-3">
                                        <FiCheckCircle className="w-5 h-5 text-orange-500 mr-3 mt-0.5 flex-shrink-0" />
                                        <span className="text-gray-600">Generator supply, installation, and rental services</span>
                                    </div>
                                    <div className="flex items-start mb-3">
                                        <FiCheckCircle className="w-5 h-5 text-orange-500 mr-3 mt-0.5 flex-shrink-0" />
                                        <span className="text-gray-600">Scheduled generator maintenance and emergency repairs</span>
                                    </div>
                                </div>
                            </div>

                            <div className="bg-orange-50 p-6 rounded-lg mb-8">
                                <h3 className="text-xl font-semibold text-orange-700 mb-3">One Team, Complete Solutions</h3>
                                <p className="text-gray-700">
                                    Unlike companies that specialize in only solar or only electrical work, our integrated approach ensures seamless coordination between all aspects of your energy system — including generator services. From solar panel installation to electrical panel upgrades and generator supply, maintenance, and rental, our certified technicians work together to deliver a cohesive, efficient, and safe energy solution for your property.
                                </p>
                            </div>

                            <p className="p-2">
                                <Link to="/quote" className="inline-block px-8 py-3 bg-orange-600 text-white font-semibold rounded-lg hover:bg-orange-700 hover:text-white transition-colors duration-300 shadow-md hover:shadow-lg transform hover:-translate-y-1">
                                    Get Your Free Energy Quotation
                                </Link>
                            </p>
                        </div>
                    </div>
                </div>
            </section>

            <section className="py-12 bg-gray-50 border-t border-gray-200">
                <div className="container mx-auto px-4">
                    <div className="max-w-5xl mx-auto">
                        <div className="grid grid-cols-1 md:grid-cols-4 gap-8 text-center">
                            <div className="p-4" data-aos="fade-up" data-aos-delay="0">
                                <div className="text-3xl font-bold text-orange-500 mb-2">15+</div>
                                <div className="text-gray-700 font-medium">Years Experience</div>
                                <div className="text-gray-500 text-sm mt-1">Electrical & Solar</div>
                            </div>
                            <div className="p-4" data-aos="fade-up" data-aos-delay="100">
                                <div className="text-3xl font-bold text-orange-500 mb-2">500+</div>
                                <div className="text-gray-700 font-medium">Projects Completed</div>
                                <div className="text-gray-500 text-sm mt-1">Electrical & Solar Projects</div>
                            </div>
                            <div className="p-4" data-aos="fade-up" data-aos-delay="200">
                                <div className="text-3xl font-bold text-orange-500 mb-2">24/7</div>
                                <div className="text-gray-700 font-medium">Emergency Support</div>
                                <div className="text-gray-500 text-sm mt-1">Electrical & Solar</div>
                            </div>
                            <div className="p-4" data-aos="fade-up" data-aos-delay="300">
                                <div className="text-3xl font-bold text-orange-500 mb-2">100%</div>
                                <div className="text-gray-700 font-medium">Satisfaction Guarantee</div>
                                <div className="text-gray-500 text-sm mt-1">Quality Assurance</div>
                            </div>
                        </div>
                    </div>
                </div>
            </section>
        </>
    );
};
export default About;